import appStoreBadge from '@/assets/badges/app-store.png'
import googlePlayBadge from '@/assets/badges/google-play.png'
import { ENV } from '@/config/env'
import { logger } from '@/utils/logger'
import { STRINGS } from '@/constants'

const CTX = 'StoreBadgesGrid'

/**
 * Two-up grid of official App Store + Google Play badges, shown on desktop
 * where deep-link / clipboard handoff to a mobile app cannot work. Both PNGs
 * are pre-padded to identical 600×200 dimensions so each cell renders at the
 * same width and height with no CSS gymnastics.
 */
export default function StoreBadgesGrid() {
  return (
    <div className="store-grid">
      <a
        href={ENV.APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => logger.info(CTX, 'desktop App Store tapped')}
        aria-label={STRINGS.qr.downloadIOS}
        className="store-link"
      >
        <img
          src={appStoreBadge}
          alt=""
          className="store-img"
          draggable={false}
        />
      </a>
      <a
        href={ENV.PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => logger.info(CTX, 'desktop Play Store tapped')}
        aria-label={STRINGS.qr.downloadAndroid}
        className="store-link"
      >
        <img
          src={googlePlayBadge}
          alt=""
          className="store-img"
          draggable={false}
        />
      </a>
    </div>
  )
}
